import { render } from "./GroupClassPlansDetail.vue?vue&type=template&id=120cec6f&scoped=true"
import script from "./GroupClassPlansDetail.vue?vue&type=script&lang=js"
export * from "./GroupClassPlansDetail.vue?vue&type=script&lang=js"

import "./GroupClassPlansDetail.vue?vue&type=style&index=0&id=120cec6f&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120cec6f"]])

export default __exports__